// What this build is: stamped in by vite.config.ts when it is built.

declare const __STARFALL_VERSION__: string;
declare const __STARFALL_COMMIT__: string;
declare const __STARFALL_BUILT__: string;

export const BUILD = {
  version: __STARFALL_VERSION__,
  /** The commit it was built from; a trailing + means uncommitted changes. */
  commit: __STARFALL_COMMIT__,
  /** When it was built, as an ISO date. */
  built: __STARFALL_BUILT__,
};

/** One line for the corner of the screen and for bug reports. */
export function buildLine(engine?: string): string {
  const parts = [`Primverse ${BUILD.version}`, BUILD.commit];
  if (engine) parts.push(`server ${engine}`);
  return parts.join(" · ");
}
